import { message } from 'antd';
import { put, takeLatest, select } from 'redux-saga/effects';
import { logger } from 'services';
import { updateSprintInProjectTemplate } from '../../actions';
import { selectTemplateSprint } from '../../selectors';
import { updateProjectTemplateSprint } from '../../slices';
function* updateSprintInTemplateSaga(action) {
    try {
        const { payload: { sprintId, payload } } = action;
        const sprint = yield select(selectTemplateSprint(sprintId));
        try {
            var _payload_fields, _sprint_fields;
            const currentFields = (sprint === null || sprint === void 0 ? void 0 : sprint.fields) && (sprint === null || sprint === void 0 ? void 0 : sprint.fields.length) > 0 ? payload.fields && ((_payload_fields = payload.fields) === null || _payload_fields === void 0 ? void 0 : _payload_fields.length) > 0 ? sprint === null || sprint === void 0 ? void 0 : (_sprint_fields = sprint.fields) === null || _sprint_fields === void 0 ? void 0 : _sprint_fields.filter((f)=>{
                var _payload_fields;
                return !((_payload_fields = payload.fields) === null || _payload_fields === void 0 ? void 0 : _payload_fields.map((x)=>x.fieldId).includes(f.fieldId));
            }) : sprint.fields : [];
            yield put(updateProjectTemplateSprint({
                sprint: {
                    ...sprint,
                    ...payload,
                    fields: (payload === null || payload === void 0 ? void 0 : payload.fields) && (payload === null || payload === void 0 ? void 0 : payload.fields.length) > 0 ? [
                        ...currentFields,
                        ...payload.fields
                    ] : currentFields
                }
            }));
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (err) {
            yield put(updateProjectTemplateSprint({
                sprint: {
                    ...sprint,
                    ...payload
                }
            }));
        }
    /**
     * Commenting out old date shift logic code
     * TODO: to be removed after thorough code walk through.
     */ // if (payload.duration || payload.startDay) {
    //   yield put(updateProjectTemplateStartdayDuration({ taskId }));
    // }
    } catch (error) {
        logger.error('updateProjectTemplateSprint failed', {
            error
        });
        message.error('There was an error updating the sprint');
    }
}
export function* watchUpdateSprintInProjectTemplateSaga() {
    yield takeLatest(updateSprintInProjectTemplate.type, updateSprintInTemplateSaga);
}
